import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./SocialL3.module.css";
import { SocialStore } from "./SocialStore";

function SocialL3({ distrito }) {
  const [empreendedorismo, setEmpreendedorismo] = useState(null);
  const [recebeRecursos, setRecebeRecursos] = useState(null);
  const [atividadeRural, setAtividadeRural] = useState(null);
  const [empreendedorismoOldValue, setEmpreendedorismoOldValue] =
    useState(null);
  const [recebeRecursosOldValue, setRecebeRecursosOldValue] = useState(null);
  const [atividadeRuralOldValue, setAtividadeRuralOldValue] = useState(null);

  const rendaExclusivaValue = SocialStore((state) => state.rendaExclusivaValue);

  const creditoRuralValue = SocialStore((state) => state.creditoRuralValue);

  const possuiEmpresaValue = SocialStore((state) => state.possuiEmpresaValue);

  const rendaPrincipalValue = SocialStore((state) => state.rendaPrincipalValue);

  const dificuldadeValue = SocialStore((state) => state.dificuldadeValue);

  const empreendedorismoValue = SocialStore(
    (state) => state.empreendedorismoValue
  );

  const recebeRecursosValue = SocialStore((state) => state.recebeRecursosValue);

  const atividadeRuralValue = SocialStore((state) => state.atividadeRuralValue);

  const setEmpreendedorismoValue = SocialStore(
    (state) => state.setEmpreendedorismoValue
  );

  const setRecebeRecursosValue = SocialStore(
    (state) => state.setRecebeRecursosValue
  );

  const setAtividadeRuralValue = SocialStore(
    (state) => state.setAtividadeRuralValue
  );

  const setEmpreendedorismoImage = SocialStore(
    (state) => state.setEmpreendedorismoImage
  );

  const setRecebeRecursosImage = SocialStore(
    (state) => state.setRecebeRecursosImage
  );

  const setAtividadeRuralImage = SocialStore(
    (state) => state.setAtividadeRuralImage
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [empreendedorismo, recebeRecursos, atividadeRural] =
          await Promise.all([
            Api.getEmpreendedorismo(
              distrito,
              rendaExclusivaValue,
              creditoRuralValue,
              possuiEmpresaValue,
              rendaPrincipalValue,
              dificuldadeValue,
              null,
              recebeRecursosValue,
              atividadeRuralValue
            ),
            Api.getRecebeRecursos(
              distrito,
              rendaExclusivaValue,
              creditoRuralValue,
              possuiEmpresaValue,
              rendaPrincipalValue,
              dificuldadeValue,
              empreendedorismoValue,
              null,
              atividadeRuralValue
            ),
            Api.getAtividadePrincipal(
              distrito,
              rendaExclusivaValue,
              creditoRuralValue,
              possuiEmpresaValue,
              rendaPrincipalValue,
              dificuldadeValue,
              empreendedorismoValue,
              recebeRecursosValue,
              null
            ),
          ]);
        setEmpreendedorismo(
          Functions.buildSmallPieGraphParams(empreendedorismo)
        );
        setRecebeRecursos(Functions.buildSmallPieGraphParams(recebeRecursos));
        setAtividadeRural(Functions.buildSmallPieGraphParams(atividadeRural));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [
    distrito,
    rendaExclusivaValue,
    creditoRuralValue,
    possuiEmpresaValue,
    rendaPrincipalValue,
    dificuldadeValue,
    empreendedorismoValue,
    recebeRecursosValue,
    atividadeRuralValue,
  ]);

  const onEmpreendedorismoClick = (value) => {
    setEmpreendedorismoValue(value);
  };

  const onRecebeRecursosClick = (value) => {
    setRecebeRecursosValue(value);
  };

  const onAtividadeRuralClick = (value) => {
    setAtividadeRuralValue(value);
  };

  return (
    <div className={styles.socialL3}>
      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {empreendedorismo && (
            <SmallPieGraph
              data={empreendedorismo}
              text="EMPREENDEDORISMO"
              onLegendClick={onEmpreendedorismoClick}
              currentValue={empreendedorismoValue}
              oldValue={empreendedorismoOldValue}
              onOldValue={setEmpreendedorismoOldValue}
              onImageReady={setEmpreendedorismoImage}
            />
          )}
        </div>
      </div>

      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {recebeRecursos && (
            <SmallPieGraph
              data={recebeRecursos}
              text="RECEBE RECURSOS"
              onLegendClick={onRecebeRecursosClick}
              currentValue={recebeRecursosValue}
              oldValue={recebeRecursosOldValue}
              onOldValue={setRecebeRecursosOldValue}
              onImageReady={setRecebeRecursosImage}
            />
          )}
        </div>
      </div>

      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {atividadeRural && (
            <SmallPieGraph
              data={atividadeRural}
              text="ATIVIDADE RURAL"
              onLegendClick={onAtividadeRuralClick}
              currentValue={atividadeRuralValue}
              oldValue={atividadeRuralOldValue}
              onOldValue={setAtividadeRuralOldValue}
              onImageReady={setAtividadeRuralImage}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default SocialL3;
